import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";
import { api } from "@/lib/api";

export default function Testimonials() {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    api.get("/reviews").then((r) => setReviews(r.data)).catch(() => {});
  }, []);

  if (!reviews.length) return null;

  return (
    <section className="relative py-24 lg:py-32 bg-panel/40" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHead
          overline="Shop Talk // From the Bays"
          title="Mechanics who run it"
          align="center"
        />
        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {reviews.map((r, i) => (
            <Reveal key={r.id} delay={i * 0.1}>
              <figure data-testid={`review-card-${r.id}`} className="h-full border border-slate-400/10 bg-panel p-7 flex flex-col">
                <div className="flex gap-1">
                  {[1, 2, 3, 4, 5].map((n) => (
                    <Star key={n} className={`w-4 h-4 ${n <= r.rating ? "text-blaze fill-blaze" : "text-slate-700"}`} />
                  ))}
                </div>
                <blockquote className="mt-4 text-sm text-slate-300 leading-relaxed flex-1">"{r.text}"</blockquote>
                <figcaption className="mt-5 pt-4 border-t border-slate-400/10">
                  <p className="font-display font-bold uppercase tracking-tight text-slate-100">{r.name}</p>
                  {r.shop && <p className="font-mono text-[10px] uppercase tracking-[0.16em] text-slate-500 mt-0.5">{r.shop}</p>}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
